import AutoSelectSellers from './auto_select_sellers';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import PrimaryProgress from '../../../containers/progress/primary_progress';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function DownloadModal({ open, handleClose, downloading, download }) {

    return(
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Seleccione el vendedor
                </Typography>
                <AutoSelectSellers />
                <div style={{marginTop: '10px'}}>
                    {
                        downloading ? <PrimaryProgress /> : 
                        <Button
                            variant="contained"
                            onClick={() => {
                                download();
                            }}
                        >
                            Descargar
                        </Button> 
                    }
                </div>                
            </Box>
        </Modal>
    );
}